import { brandName, navItems } from "@/mocks/comicGuide";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-background-200">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-8 px-4 py-12 sm:grid-cols-3 md:px-6">
        <div className="sm:col-span-1">
          <a href="#home" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <i className="ri-book-2-fill text-lg"></i>
            </span>
            <span className="font-heading text-xl text-foreground-950">{brandName}</span>
          </a>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            专注漫画软件应用使用技巧，分享阅读模式、夜间模式、缓存、订阅与离线阅读等实用内容。
          </p>
        </div>

        <div>
          <h4 className="text-sm font-bold text-foreground-900">内容导航</h4>
          <ul className="mt-4 space-y-2">
            {navItems.map((item) => (
              <li key={item.id}>
                <a href={`#${item.id}`} className="text-sm text-foreground-600 transition hover:text-primary-600">
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold text-foreground-900">关于本站</h4>
          <ul className="mt-4 space-y-2 text-sm text-foreground-600">
            <li><a href="#about" className="transition hover:text-primary-600">关于我们</a></li>
            <li><a href="#faq" className="transition hover:text-primary-600">常见问题</a></li>
            <li><a href="mailto:hello@manduzhinan.example.com" className="transition hover:text-primary-600">联系交流</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-300">
        <div className="mx-auto flex w-full max-w-6xl flex-col items-center justify-between gap-2 px-4 py-5 text-sm text-foreground-500 sm:flex-row md:px-6">
          <p>© {year} {brandName} 保留所有权利</p>
          <p className="flex items-center gap-1">
            漫画阅读 · 追漫更轻松 <i className="ri-heart-3-fill text-accent-500"></i>
          </p>
        </div>
      </div>
    </footer>
  );
}